// Loading screen stub. Per spec/build-plan.md P-022 row.
//
// **Not mounted at boot.** `loadPersistedState()` is synchronous
// (`localStorage.getItem` + `JSON.parse` + `AppStateSchema.safeParse`,
// sub-10 ms); inserting a loading screen between seeding the store
// and mounting `<App />` would just flash. The file lands as a ready-
// to-use component for P-024+ if any read-only screen surfaces real
// async work, or for the future preview-iframe / external-fetch flow.
//
// **Coverage exclusion.** Per the D-083 vitest.config.ts globs,
// `src/app/screens/**` is excluded until P-024 introduces real screen
// logic with non-trivial branches worth pinning. This file is
// presentation-only stub markup; coverage at this scope is low ROI.

export function LoadingScreen() {
  return (
    <div role="status" aria-live="polite" class="flex items-center justify-center p-8">
      <p class="m-0 text-sm text-gray-600">Loading…</p>
    </div>
  )
}
